// Module-level handoff store: when a user drops files on the home page
// dropzone, we hold them here and the destination tool route consumes them
// on mount. File objects can't survive sessionStorage and we don't want to
// bring in a state library for one signal — a tiny pubsub does the job.
const EMPTY: readonly File[] = Object.freeze([]);
let pending: readonly File[] = EMPTY;
const listeners = new Set<() => void>();

export function setPendingFiles(files: File[]): void {
  pending = files.length ? Object.freeze([...files]) : EMPTY;
  for (const cb of listeners) cb();
}

export function getPendingFiles(): readonly File[] {
  return pending;
}

// Drains the staged files; if a predicate is given, only matching files are
// returned and the rest are discarded. Always clears the slot.
export function takePendingFiles(predicate?: (file: File) => boolean): File[] {
  if (pending.length === 0) return [];
  const matched = predicate ? pending.filter(predicate) : [...pending];
  pending = EMPTY;
  for (const cb of listeners) cb();
  return matched;
}

export function fileMatchesExtensions(file: File, extensions: string[]): boolean {
  const name = file.name.toLowerCase();
  return extensions.some((ext) => name.endsWith(ext.toLowerCase()));
}
